import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';
import { BG_CONTAINER_COLORS } from '../../colors';

const addBackgroundColorStyling = ({ schema, intl }) => {
  addStyling({ schema, intl });

  const styleFieldset = schema.properties.styles?.schema?.fieldsets?.[0];
  const styleProperties = schema.properties.styles?.schema?.properties;

  if (!styleFieldset || !styleProperties) return schema;

  styleFieldset.fields = styleFieldset.fields.filter(
    (field) => field !== "surfaceTheme",
  );

  delete styleProperties.surfaceTheme;

  if (!styleFieldset.fields.includes('backgroundColor')) {
    styleFieldset.fields = [...styleFieldset.fields, 'backgroundColor'];
  }

  styleProperties.backgroundColor = {
    title: 'Background color',
    widget: 'color_picker',
    colors: BG_CONTAINER_COLORS,
    default: 'transparent',
  };

  return schema
};

export default addBackgroundColorStyling;
